import React from 'react';
import { Grid, GridItem, Icon } from '../../common';
import { map } from 'lodash';
import { pxToRem } from '../../../utils/dimensionConverter';

const CountListTitle = ({ title, count }) => {
  return (
    <Grid>
      <GridItem tagName='li' small={12} medium={12}>
        <div className="count-title">
          <Icon name='down-arrow' size={pxToRem(8)}/>
          <span className='title-list'>{title}</span>
          <span className="count">{count}</span>
        </div>
      </GridItem>
    </Grid>
  )
}

const TableHeader = ({ titles }) => {
  const titleList = () => {
    return map(titles, ({ title, sm, md }, id) => {
      return (
        <GridItem tagName='li' small={sm} medium={md} key={id}>
          <div className="table__title">
            <span>{ title }</span>
          </div>
        </GridItem>
      )
    })
  }

  return (
    <div className="table__header">
      <Grid tagName='ul'>
        { titleList() }
      </Grid>
    </div>
  )
}

  const TableContent = ({ listComponent }) => {
    return (
      <div className="table__list">
        <Grid tagName='ul'>
          { listComponent }
        </Grid>
      </div>
    )
  }
export const Table = ({ headerTitles, listComponent, count, countTitle }) => {
  return (
    <section className="table">
      { countTitle && <CountListTitle count={count} title={countTitle}/> }
      { headerTitles && <TableHeader titles={headerTitles}/> }
      <TableContent listComponent={listComponent}/>
    </section>
  )
}

export default Table;